import { candleParser } from '../candleParser';

/**
 * {
	"messageType": "alertNotification",
	"notificationId": 1645476881174,
	"notificationDetails": {"updateType":"SETUP_TRIGGERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_TRIGGERED",
	"statusDetails": {"pluginTemplate":{"candleDuration":1,"timeUnit":"DAYS","candle":{"high":101.0,"low":99.0,"open":100.0,"close":100.25,"candleSymbol":"XYZ","candleStartTimeStamp":1641110640000,"duration":"1DAYS"}},"triggerPrice":100.0,"tradeDirection":"LONG","tacticName":"CANDLE_TRIGGER","symbol":"XYZ"},
	"date": "2022-02-21T15:54:41.794-0500",
	"timestamp": "1645476881796"
}

 * @param {*} pluginTemplate 
 * @returns object with fields:
 * 1) candleDuration
 * 2) timeUnit
 * 3) candle (object with fields: high,low,open,close,candleSymbol,duration,candleStartTimeStamp)
 */
export function candleTriggerParser(pluginTemplate) {
  const parsedObject = {
    candleDuration: null,
    timeUnit: null,
    candle: null,
  };
  if (pluginTemplate) {
    parsedObject.candleDuration = pluginTemplate.candleDuration;
    parsedObject.timeUnit = pluginTemplate.timeUnit;
    const candle = candleParser(pluginTemplate.candle);
    if (candle) {
      parsedObject.candle = candle;
    }
  }
  return parsedObject;
}
